document.addEventListener("alpine:init", () => {
  Alpine.data("Theme_Header", () => ({
    isStuck: false,
    overlayHeaderWithSticky: null,
    menus: [],
    activeSubMenus: [],
    activeSubMenuHandle: null,
    activeSubMenu: {},
    activeGrandChildMenu: [],
    showMegaMenu: false,
    megaImageSlotActive: null,
    overlayTextColor: null,
    menuItemActive: Alpine.$persist("").as("pcActiveMenuItem"),
    init() {
      this.overlayHeaderWithSticky =
        this.$root.dataset.overlayHeaderWithSticky === "true";

      if (this.overlayHeaderWithSticky) {
        this.setUpOverlayWithSticky();
      }
      this.menus = JSON.parse(this.$refs.menuData.innerText);
      var that = this;
      if(this.menuItemActive){
        this.activeSubMenus = this.menus.filter(menu => menu.handle === that.menuItemActive)[0]?.links || [];
      }
      this.$watch('menuItemActive', (menuItemActive)=>{
        that.activeSubMenus = that.menus.filter(menu => menu.handle === menuItemActive)[0]?.links || [];
      });
      this.$watch('activeSubMenu', (activeSubMenu)=>{
        if(activeSubMenu.links && activeSubMenu.links.length > 0 ){
          Alpine.store('header').megaImageSlotActive = `${that.menuItemActive}_${activeSubMenu.handle}`;
          if(!that.showMegaMenu){
            that.showMegaMenu = true;
          }
        }else{
          that.showMegaMenu = false;
        }
      });
      this.$nextTick(()=>{
              if (this.$root.getAttribute("data-sticky")) {
        document.documentElement.style.setProperty(
          "--sticky-header-height",
          `${this.$root.getBoundingClientRect().height}px`
        );
      } else {
        document.documentElement.style.setProperty(
          "--sticky-header-height",
          "0"
        );
      }
      })
    },
    setUpOverlayWithSticky() {
      const positionerEl = document.createElement("div");
      positionerEl.id = "sticky-positioner";

      document.body.insertBefore(
        positionerEl,
        this.$root.closest(".shopify-section")
      );

      const observer = new IntersectionObserver(([e]) => {
        e.intersectionRatio === 0
          ? (this.isStuck = true)
          : (this.isStuck = false);
      });

      observer.observe(positionerEl);

      this.overlayTextColor = this.$root.dataset.overlayTextColorScheme;

      this.updateColorScheme(this.isStuck);

      this.$watch("isStuck", (value) => {
        this.updateColorScheme(value);
      });
    },
    updateColorScheme(isStuck) {
      if (isStuck) {
        this.$refs.header.setAttribute("data-color-scheme", "");
        this.$refs.header.classList.remove("bg-transparent");
        this.$refs.header.classList.add("bg-scheme-background");
      } else {
        this.$refs.header.setAttribute(
          "data-color-scheme",
          this.overlayTextColor
        );
        this.$refs.header.classList.remove("bg-scheme-background");
        this.$refs.header.classList.add("bg-transparent");
      }
    },
  }));
  Alpine.store('header', {
    megaImageSlotActive: null,
  })
});
